// Turns the refund/cancellation fields a director saves (Profile → Payment → Cancellation Policy)
// into what the checkout modal needs to render. Anything missing or non-numeric falls back to the
// "no refund" / blank states rather than printing "undefined%".

const num = value => {
    if (value === '' || value === null || value === undefined) return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
};

const methodLabel = type => (Number(type) === 2 ? 'Original Form of Payment' : 'Program Voucher');

const parseOptions = options => {
    if (Array.isArray(options)) return options;
    if (typeof options === 'string') {
        try {
            const parsed = JSON.parse(options);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    }
    return [];
};

export const toPolicyView = item => {
    const tiers = parseOptions(item.refundOptions)
        // The director form stores these two keys swapped: `days` holds the refund percent and
        // `percent` holds the number of days before the program starts. Do not "fix" the names
        // here without migrating every saved policy.
        .map(row => ({ pct: num(row && row.days), days: num(row && row.percent) }))
        .filter(tier => tier.pct !== null && tier.days !== null)
        .sort((a, b) => b.pct - a.pct);

    return {
        campName: item.campName,
        parent: {
            available: Number(item.refundAvailable) === 1,
            method: methodLabel(item.refundType),
            tiers,
            maxPct: tiers.length ? tiers[0].pct : null,
        },
        provider: {
            available: Number(item.cancellationAvailable) === 1,
            method: methodLabel(item.cancellationType),
            pct: num(item.cancellationValue),
        },
    };
};
